module.exports = __webpack_public_path__ + "static/media/ai-tips-icon.d375e67c.svg";